










import AppSvgIcon from "@/uikit/components/AppSvgIconNew";
export default {
  name: "AddEditStudyPlaceHeader",
  components: {
    AppSvgIcon
  },
  props: {
    title: String
  },
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/study/components/AddEditStudyPlaceHeader.vue